var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrade300(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24px/trade_300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.55383 17.5483L2.5 16.4944L9.3519 9.59256L13.3519 13.5926L18.9654 8.04829H16V6.54834H21.5V12.0483H20V9.10211L13.3519 15.7502L9.3519 11.7502L3.55383 17.5483Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade300);
export default __webpack_public_path__ + "static/media/trade_300.6e15f75432f44686b8c1c25f45e68c0b.svg";
export { ForwardRef as ReactComponent };